module.exports = __webpack_public_path__ + "img/robo_con_repise.4a3cb234.gif";